<mat-card class="cardWithShadow">
    <mat-card-header class="header-container">
        <mat-card-title>
            <mat-card-title>{{ 'SCANS_UNLOCKED_BY_SUBSCRIPTION' | translate }}</mat-card-title>
            <span class="subtitle">{{ 'WHO_IS_GETTING_CHARGED' | translate }}</span>
        </mat-card-title>
        <div class="d-flex flex-column">
            <mat-button-toggle-group [(ngModel)]="selectedTimeRange"
                (change)="handleSelectedTimeRangeChange($event.value)" [hideSingleSelectionIndicator]="true">
                <mat-button-toggle value="3 meses">{{ '3_MONTHS' | translate }}</mat-button-toggle>
                <mat-button-toggle value="6 meses">{{ '6_MONTHS' | translate }}</mat-button-toggle>
                <mat-button-toggle value="12 meses">{{ '12_MONTHS' | translate }}</mat-button-toggle>
            </mat-button-toggle-group>
            <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
        </div>
    </mat-card-header>
    <mat-card-content class="card-body">
        <div *ngIf="(userPermissions | hasPermission:'analytics.detailed_by_distributor.view_total_by_subscription') || user.role !== 'ROLE_ADMIN'"
            style="display: flex; flex-direction: row; flex-flow: wrap; gap: 25px; justify-content: center; padding-top: 22px;">
            <div>
                <apx-chart [series]="charts.oldSubscriptionLineChart.series"
                    [chart]="charts.oldSubscriptionLineChart.chart" [xaxis]="charts.oldSubscriptionLineChart.xaxis"
                    [yaxis]="charts.oldSubscriptionLineChart.yaxis" [grid]="charts.oldSubscriptionLineChart.grid"
                    [stroke]="charts.oldSubscriptionLineChart.stroke"
                    [tooltip]="charts.oldSubscriptionLineChart.tooltip"
                    [dataLabels]="charts.oldSubscriptionLineChart.dataLabels"
                    [legend]="charts.oldSubscriptionLineChart.legend" [colors]="charts.oldSubscriptionLineChart.colors"
                    [markers]="charts.oldSubscriptionLineChart.markers" [fill]="charts.oldSubscriptionLineChart.fill"
                    [title]="charts.oldSubscriptionLineChart.title" [labels]="charts.oldSubscriptionLineChart.labels">
                </apx-chart>
            </div>
            <div>
                <apx-chart [series]="charts.basicSubscriptionLineChart.series"
                    [chart]="charts.basicSubscriptionLineChart.chart" [xaxis]="charts.basicSubscriptionLineChart.xaxis"
                    [yaxis]="charts.basicSubscriptionLineChart.yaxis" [grid]="charts.basicSubscriptionLineChart.grid"
                    [stroke]="charts.basicSubscriptionLineChart.stroke"
                    [tooltip]="charts.basicSubscriptionLineChart.tooltip"
                    [dataLabels]="charts.basicSubscriptionLineChart.dataLabels"
                    [legend]="charts.basicSubscriptionLineChart.legend"
                    [colors]="charts.basicSubscriptionLineChart.colors"
                    [markers]="charts.basicSubscriptionLineChart.markers"
                    [fill]="charts.basicSubscriptionLineChart.fill" [title]="charts.basicSubscriptionLineChart.title"
                    [labels]="charts.basicSubscriptionLineChart.labels">
                </apx-chart>
            </div>
            <div>
                <apx-chart [series]="charts.advancedSubscriptionLineChart.series"
                    [chart]="charts.advancedSubscriptionLineChart.chart"
                    [xaxis]="charts.advancedSubscriptionLineChart.xaxis"
                    [yaxis]="charts.advancedSubscriptionLineChart.yaxis"
                    [grid]="charts.advancedSubscriptionLineChart.grid"
                    [stroke]="charts.advancedSubscriptionLineChart.stroke"
                    [tooltip]="charts.advancedSubscriptionLineChart.tooltip"
                    [dataLabels]="charts.advancedSubscriptionLineChart.dataLabels"
                    [legend]="charts.advancedSubscriptionLineChart.legend"
                    [colors]="charts.advancedSubscriptionLineChart.colors"
                    [markers]="charts.advancedSubscriptionLineChart.markers"
                    [fill]="charts.advancedSubscriptionLineChart.fill"
                    [title]="charts.advancedSubscriptionLineChart.title"
                    [labels]="charts.advancedSubscriptionLineChart.labels">
                </apx-chart>
            </div>
            <div>
                <apx-chart [series]="charts.proSubscriptionLineChart.series"
                    [chart]="charts.proSubscriptionLineChart.chart" [xaxis]="charts.proSubscriptionLineChart.xaxis"
                    [yaxis]="charts.proSubscriptionLineChart.yaxis" [grid]="charts.proSubscriptionLineChart.grid"
                    [stroke]="charts.proSubscriptionLineChart.stroke"
                    [tooltip]="charts.proSubscriptionLineChart.tooltip"
                    [dataLabels]="charts.proSubscriptionLineChart.dataLabels"
                    [legend]="charts.proSubscriptionLineChart.legend" [colors]="charts.proSubscriptionLineChart.colors"
                    [markers]="charts.proSubscriptionLineChart.markers" [fill]="charts.proSubscriptionLineChart.fill"
                    [title]="charts.proSubscriptionLineChart.title" [labels]="charts.proSubscriptionLineChart.labels">
                </apx-chart>
            </div>
            <div>
                <apx-chart [series]="charts.threeDInsolesDesignSubscriptionLineChart.series"
                    [chart]="charts.threeDInsolesDesignSubscriptionLineChart.chart"
                    [xaxis]="charts.threeDInsolesDesignSubscriptionLineChart.xaxis"
                    [yaxis]="charts.threeDInsolesDesignSubscriptionLineChart.yaxis"
                    [grid]="charts.threeDInsolesDesignSubscriptionLineChart.grid"
                    [stroke]="charts.threeDInsolesDesignSubscriptionLineChart.stroke"
                    [tooltip]="charts.threeDInsolesDesignSubscriptionLineChart.tooltip"
                    [dataLabels]="charts.threeDInsolesDesignSubscriptionLineChart.dataLabels"
                    [legend]="charts.threeDInsolesDesignSubscriptionLineChart.legend"
                    [colors]="charts.threeDInsolesDesignSubscriptionLineChart.colors"
                    [markers]="charts.threeDInsolesDesignSubscriptionLineChart.markers"
                    [fill]="charts.threeDInsolesDesignSubscriptionLineChart.fill"
                    [title]="charts.threeDInsolesDesignSubscriptionLineChart.title"
                    [labels]="charts.threeDInsolesDesignSubscriptionLineChart.labels">
                </apx-chart>
            </div>
            <div>
                <apx-chart [series]="charts.threeDAfoDesignSubscriptionLineChart.series"
                    [chart]="charts.threeDAfoDesignSubscriptionLineChart.chart"
                    [xaxis]="charts.threeDAfoDesignSubscriptionLineChart.xaxis"
                    [yaxis]="charts.threeDAfoDesignSubscriptionLineChart.yaxis"
                    [grid]="charts.threeDAfoDesignSubscriptionLineChart.grid"
                    [stroke]="charts.threeDAfoDesignSubscriptionLineChart.stroke"
                    [tooltip]="charts.threeDAfoDesignSubscriptionLineChart.tooltip"
                    [dataLabels]="charts.threeDAfoDesignSubscriptionLineChart.dataLabels"
                    [legend]="charts.threeDAfoDesignSubscriptionLineChart.legend"
                    [colors]="charts.threeDAfoDesignSubscriptionLineChart.colors"
                    [markers]="charts.threeDAfoDesignSubscriptionLineChart.markers"
                    [fill]="charts.threeDAfoDesignSubscriptionLineChart.fill"
                    [title]="charts.threeDAfoDesignSubscriptionLineChart.title"
                    [labels]="charts.threeDAfoDesignSubscriptionLineChart.labels">
                </apx-chart>
            </div>
            <div>
                <apx-chart [series]="charts.threeDSpinalBraceDesignSubscriptionLineChart.series"
                    [chart]="charts.threeDSpinalBraceDesignSubscriptionLineChart.chart"
                    [xaxis]="charts.threeDSpinalBraceDesignSubscriptionLineChart.xaxis"
                    [yaxis]="charts.threeDSpinalBraceDesignSubscriptionLineChart.yaxis"
                    [grid]="charts.threeDSpinalBraceDesignSubscriptionLineChart.grid"
                    [stroke]="charts.threeDSpinalBraceDesignSubscriptionLineChart.stroke"
                    [tooltip]="charts.threeDSpinalBraceDesignSubscriptionLineChart.tooltip"
                    [dataLabels]="charts.threeDSpinalBraceDesignSubscriptionLineChart.dataLabels"
                    [legend]="charts.threeDSpinalBraceDesignSubscriptionLineChart.legend"
                    [colors]="charts.threeDSpinalBraceDesignSubscriptionLineChart.colors"
                    [markers]="charts.threeDSpinalBraceDesignSubscriptionLineChart.markers"
                    [fill]="charts.threeDSpinalBraceDesignSubscriptionLineChart.fill"
                    [title]="charts.threeDSpinalBraceDesignSubscriptionLineChart.title"
                    [labels]="charts.threeDSpinalBraceDesignSubscriptionLineChart.labels">
                </apx-chart>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<!-- Clients Stats Table -->
<mat-card
    *ngIf="(userPermissions | hasPermission:'analytics.detailed_by_distributor.view_clients_table') || user.role !== 'ROLE_ADMIN'"
    class="cardWithShadow">
    <mat-card-header style="margin-bottom: 15px;">
        <mat-card-title>
            <mat-card-title>{{ 'CLIENTS' | translate }}</mat-card-title>
            <span class="subtitle">{{ 'CLIENTS_DETAILED_STATISTICS' | translate }}</span>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="row">
            <div class="col-2">
                <div class="row animated fadeIn fast" *ngIf="isLoading">
                    <div class="col-12 text-center">
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">{{ "LOADING" | translate }}...</span>
                        </div>
                        <p class="mb-0 text-primary">{{ 'PLEASE_WAIT' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="loading" *ngIf="isLoading">
            <ngx-skeleton-loader [count]="10" [theme]="{ 'border-radius': '0', height: '50px' }" [appearance]="'line'">
            </ngx-skeleton-loader>
        </div>
        <p-table #dt *ngIf="!isLoading" [value]="filteredMonthlyChargesAccountingTableData" [columns]="cols"
            [paginator]="true" [loading]="isLoading" [rows]="10" [responsive]="true" [scrollable]="true"
            [scrollHeight]="'flex'" [globalFilterFields]="['clientName', 'yearMonth', 'chargedTo']"
            [exportHeader]="'customExportHeader'">

            <ng-template pTemplate="caption">
                <div class="text-end pb-4">
                    <p-button icon="pi pi-external-link" [label]="'EXPORT' | translate" (click)="dt.exportCSV()" />
                </div>
            </ng-template>
            <!-- Column Definitions -->
            <ng-template pTemplate="header">
                <tr>
                    <th style="display: flex; flex-direction: column; gap: 8px;">
                        <span>{{ 'CLIENT' | translate }}</span>
                        <p-columnFilter [field]="'clientName'" [matchMode]="'contains'"
                            style="width: 300px;"></p-columnFilter>
                    </th>
                    <th pSortableColumn="yearMonth">{{ 'MONTH' | translate }}</th>
                    <th style="display: flex; flex-direction: column; gap: 5px;">
                        <span>{{ 'CHARGED_TO' | translate }}</span>
                        <!-- Dropdown Filter -->
                        <p-dropdown [options]="chargedToOptions" [(ngModel)]="chargedToFilter"
                            (onChange)="dt.filter($event.value, 'chargedTo', 'equals')"
                            [placeholder]="'SELECT_FILTER' | translate" [showClear]="true">
                            <ng-template let-option pTemplate="item">
                                <span>{{ option | translate }}</span>
                            </ng-template>
                            <ng-template let-selected pTemplate="selectedItem">
                                <span>{{ selected | translate }}</span>
                            </ng-template>
                        </p-dropdown>
                    </th>
                    <th pSortableColumn="calculatedBasic">{{ 'BASIC' | translate }}</th>
                    <th pSortableColumn="calculatedAdvanced">{{ 'ADVANCED' | translate }}</th>
                    <th pSortableColumn="calculatedPro">{{ 'PRO' | translate }}</th>
                    <th pSortableColumn="calculatedInsoles">{{ 'INSOLES' | translate }}</th>
                    <th pSortableColumn="calculatedAfo">{{ 'AFO' | translate }}</th>
                    <th pSortableColumn="calculatedSpinalBrace">{{ 'SPINAL_BRACE' | translate }}</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td class="text-muted"
                        *ngIf="user.role === 'ROLE_ADMIN' && !(userPermissions | hasPermission:'analytics.detailed_by_distributor.view_clients_table.view_client_name')">
                        {{ 'PERMISSION_REQUIRED' | translate }} <i class="pi pi-lock me-1"></i>
                    </td>

                    <td
                        *ngIf="user.role !== 'ROLE_ADMIN' || (userPermissions | hasPermission:'analytics.detailed_by_distributor.view_clients_table.view_client_name')">
                        {{ rowData.clientName }}
                    </td>
                    <td>{{ rowData.yearMonth }}</td>
                    <td class="text-center">
                        <!-- Condicional para mostrar badge según 'chargedTo' -->
                        <span [ngClass]="{
                                    'custom-badge': true, 
                                    'client': rowData.chargedTo === 'Client',
                                    'distributor': rowData.chargedTo === 'Distributor'
                                }">
                            {{ rowData.chargedTo | translate }}
                        </span>
                    </td>
                    <td class="text-center">{{ rowData.calculatedBasic }}</td>
                    <td class="text-center">{{ rowData.calculatedAdvanced }}</td>
                    <td class="text-center">{{ rowData.calculatedPro }}</td>
                    <td class="text-center">{{ rowData.calculatedInsoles }}</td>
                    <td class="text-center">{{ rowData.calculatedAfo }}</td>
                    <td class="text-center">{{ rowData.calculatedSpinalBrace }}</td>
                </tr>
            </ng-template>

        </p-table>
    </mat-card-content>

</mat-card>